import { useCallback, useEffect, useState } from 'react';
import { fetchFundingDashboardSummary } from '../../services/funding';
import { useFundingWorkspace } from '../../context/FundingWorkspaceContext';

export function useFundingDashboard() {
  const { workspaceAgencyId } = useFundingWorkspace();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!workspaceAgencyId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const summary = await fetchFundingDashboardSummary(workspaceAgencyId);
      setData(summary);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load dashboard');
    } finally {
      setLoading(false);
    }
  }, [workspaceAgencyId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, loading, error, refresh, workspaceAgencyId };
}
